import {Component, EventEmitter, Inject, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {customSetTimeout} from "../../../core/helpers/overrided-timers";
import {DOCUMENT, NgClass, NgIf, NgStyle} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {IconModule} from "../../../../../shared/assets/icons/ts/icon.module";

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    NgStyle,
    TranslateModule,
    IconModule
  ],
  encapsulation: ViewEncapsulation.None
})
export class ModalComponent implements OnInit {
  @Input() dialogClass: any;
  @Input() hideHeader = false;
  @Input() visibleTop: any;
  @Input() hideFooter = false;
  @Output()hideCallback =  new EventEmitter();
  @Input() containerClick = true;
  @Input() customStyle = null;

  constructor(
      @Inject(DOCUMENT) private dom) { }
  public visible = false;
  public visibleAnimate = false;

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {
  }

  public show(): void {

    this.visible = true;
    customSetTimeout(() => this.visibleAnimate = true, 100);
    // @ts-ignore
    this.dom.querySelector('body').classList.add('modal-open');
  }

  public hide(): void {
    this.visibleAnimate = false;
    customSetTimeout(() => this.visible = false, 300);
    // @ts-ignore
    this.dom.querySelector('body').classList.remove('modal-open');
    this.hideCallback.emit()
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('modal') && this.containerClick) {
      this.hide();
    }
  }


}
